<template>
  <div>
    <loader :loading="loading"></loader>
    <div v-if="!loading" v-html="compiledHTML"></div>
  </div>
</template>

<script>
import axios from "axios";
import ProductService from "@/services/ProductService";
import { mapState, mapActions } from "vuex";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    Loader,
  },
  data() {
    return {
      compiledHTML: "",
      fileName: "under_maintenance.html",
      loading: false,
    };
  },
  computed: {
    ...mapState("Root", ["underMaintenance"]),
  },

  async mounted() {
    console.log("ONMOUNT", this.underMaintenance);
    //Check is Under Maintenance, If it is set false, recheck
    if (!this.underMaintenance) {
      try {
        this.loading = true;
        await ProductService.all();
        this.loading = false;
        if (!this.underMaintenance) {
          window.location.assign("/progressive-advantage/");
        }
      } catch (error) {
        this.loading = false;
      }
    }

    axios({
      method: "get",
      url: `${process.env.API_URL}/rest/V1/ccmsBlock/${process.env.MAINTENANCE}`,
    })
      .then((result) => {
        if (result.data && result.data.content) {
          let htmlString = new DOMParser().parseFromString(
            result.data.content,
            "text/html"
          );
          this.compiledHTML = htmlString.documentElement.textContent;
        }
      })
      .catch((error) => {
        console.error("error getting file");
      });
  },
  methods: {
    ...mapActions("Root", ["setUnderMaintenance"]),
  },
};
</script>
